import { KeyValPair } from "@models/common.model"
import { createContext, ReactNode, useReducer } from "react"
import OptionsWrapper from "./optionsWrapper"
import OptionReducer, { ActionType } from "./reducer"

export interface OptionsProps {
  product?: KeyValPair[]
  contract?: KeyValPair[]
  project?: KeyValPair[]
  project_group?: KeyValPair[]
  module?: KeyValPair[]
  profile?: KeyValPair[]
  role?: KeyValPair[]
  organization?: KeyValPair[]
}

const initialGlobalState: OptionsProps = {}

export const OptionsContext = createContext<{
    state: OptionsProps
    dispatch: React.Dispatch<ActionType>
  }>({
    state: initialGlobalState,
    dispatch: () => undefined,
  })

interface Props {
    children?: ReactNode
}

export const OptionsProvider = ({ children, ...props }: Props)  => {
    const [state, dispatch] = useReducer(OptionReducer, initialGlobalState)

    return (
        <OptionsContext.Provider
          value={{ state, dispatch }}>
            <OptionsWrapper>{children}</OptionsWrapper>
        </OptionsContext.Provider>
      )
}
